jQuery(document).ready(function ($) {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var blocs = document.querySelectorAll('.bloc_paraphotos');

    if (!blocs.length) {
        return;
    }

    var DUREE = 1.1;
    var EASE = 'power3.inOut';

    var DECLENCHEMENT = 'top 80%';

    function mesurer(photos) {
        var ratio = parseFloat(getComputedStyle(photos).getPropertyValue('--balayage-ratio'));

        if (isNaN(ratio)) {
            return null;
        }

        return {
            biais: photos.offsetHeight * ratio,
            largeur: photos.offsetWidth
        };
    }

    Array.prototype.forEach.call(blocs, function (bloc) {
        // .photos et pas les figure : bxSlider reecrit le DOM sous .slider
        var photos = bloc.querySelector('.photos');

        if (!photos) {
            return;
        }

        gsap.set(photos, {'--balayage': '-100%'});

        ScrollTrigger.create({
            trigger: bloc,
            start: DECLENCHEMENT,
            once: true,
            onEnter: function () {
                var mesure = mesurer(photos);

                if (!mesure) {
                    gsap.set(photos, {'--balayage': '100%'});
                    return;
                }

                gsap.set(photos, {
                    '--balayage-biais': mesure.biais + 'px',
                    '--balayage': -mesure.biais + 'px'
                });

                gsap.to(photos, {
                    '--balayage': mesure.largeur + 'px',
                    duration: DUREE,
                    ease: EASE,
                    // retour aux defauts en % : plus rien a recalculer au resize
                    onComplete: function () {
                        gsap.set(photos, {
                            '--balayage-biais': '0px',
                            '--balayage': '100%'
                        });
                    }
                });
            }
        });
    });
});
